// src/redux/slices/paymentSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { payment } from "../apiPath/api";

// Create the async thunk for fetching payments
export const fetchPayments = createAsyncThunk(
  "payments/fetchPayments",
  async (params, { rejectWithValue }) => {
    try {
      const response = await payment.getPayment(params);
      return response.data;
    } catch (error) {
      const errorMsg =
        error.response?.data?.message || error.message || "Failed to fetch payments";
      return rejectWithValue(errorMsg);
    }
  }
);

// Define the initial state
const initialState = {
  payments: [],
  loading: false,
  error: null,
  pagination: { total: 0, page: 1, limit: 10, totalPages: 1 },
  statusCounts: { all: 0, pending: 0, success: 0, failed: 0, cancelled: 0 },
  success: false,
};

const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    resetPaymentState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.payments = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPayments.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(fetchPayments.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        // The payload from the backend is expected to have data, pagination, and statusCounts
        state.payments = action.payload.data;
        state.pagination = action.payload.pagination;
        state.statusCounts = action.payload.statusCounts;
      })
      .addCase(fetchPayments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
        state.payments = []; // Clear data on error
      });
  },
});

export const { resetPaymentState } = paymentSlice.actions;
export default paymentSlice.reducer;